var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"linkedin","d":"M5.757,24.244V7.887H.321V24.244ZM3.04,5.652A2.835,2.835,0,1,0,3.076,0,2.834,2.834,0,1,0,3,5.652H3.04ZM8.767,24.244H14.2V15.109a3.722,3.722,0,0,1,.179-1.326,2.976,2.976,0,0,1,2.79-1.989c1.967,0,2.754,1.5,2.754,3.7v8.751h5.437V14.865C25.363,9.84,22.68,7.5,19.1,7.5a5.415,5.415,0,0,0-4.936,2.756H14.2V7.886H8.767c.071,1.535,0,16.357,0,16.357Z"}));
}

Linkedin.defaultProps = {"width":"25.363","height":"24.244","viewBox":"0 0 25.363 24.244"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
